import React, { useImperativeHandle, useState } from "react"
import Modal from "../Modal";
import Button from "./Button";

const StatusModal = React.forwardRef(({ }, ref) => {

    const [isVisible, setIsVisible] = useState(false);
    const [modalValues, setModalValues] = useState({
        title: "",
        content: "",
        isSuccess: false
    });

    useImperativeHandle(ref, () => ({

        openModal({ title, content, isSuccess }) {
            setModalValues({
                title, content, isSuccess
            });
            setIsVisible(true);
        }

    }));



    return (
        <Modal openModal={isVisible} setOpenModal={setIsVisible}>
            <div>
                <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <h3 className="text-md leading-6 font-medium text-gray-900">
                            {modalValues.title}
                        </h3>
                        <div className="flex justify-center">
                            <div className="mt-4 flex flex-row items-center">
                                <img
                                    className="text-error h-10 w-10"
                                    src={modalValues.isSuccess ? "/icons/basarili.svg" : "/icons/basarisiz.svg"}
                                    alt=""
                                />
                                <p className="pl-1 text-sm text-gray-500">
                                    {modalValues.content}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-5 sm:mt-4 flex justify-end space-x-2">
                    <Button
                        color="primary"
                        hover="primary"
                        size="xs"
                        callback={() => setIsVisible(false)}
                    >
                        Kapat
                    </Button>
                </div>
            </div>
        </Modal>
    );
})

export default StatusModal;